export class CartaCorrecao {
  constructor() {
    this.carta_correcao_id = '';
    this.nota_id = '';
    this.texto_correcao = [];/*data-ordem-motivo*/
  }
}
